export default {
  "7e114ac94166f7e763dcb44d63aa8e1a": "下單頁",
  "b5fe836a6d3fbbc5e95129cead17d40e": "擴科組件曝光",
  "c2af4fcf5b90cb9f179e3cdce608a2ee": "商城訂單確認頁_優惠券挽留彈窗_確認按鈕",
  "57950bd46fa47fb8fcea3b20c1c288fb": "收下並使用",
  "bcbd6b44312685a43800b922f199df8a": "領取失敗",
  "f644fb9a4519355a8da1f64fc94edb66": "該商品暫時無法購買，請聯繫客服",
  "8ce562997645526239623f8f72931c3c": "未選擇地址",
  "19468132a5f1e5c21f8b70574a6ba49f": "未選擇支付方式",
  "cad27f9072af037e76552b1bb37a4f3c": "確認訂單收銀台-立即支付按鈕點擊",
  "890ca4dbf6dcad1eac1ae40d607f73e3": "優惠券ID：",
  "efcbc88e75d142089eede97f8289b645": "; 代金券ID：",
  "281253962349ff8082ff1027931ef76b": "; 合計價格：",
  "f05994bf4fe507e9d499dc42fccec46e": "商城訂單確認頁_底部按鈕",
  "7c80332494d33b2f1f87a723cac1707f": "商城訂單確認頁_優惠券點擊",
  "321ae2d2073ac59fe31b3f509bbdd216": "已下架",
  "b202d974ceeb3ede24e96c1fa17e93ac": "已售罄",
  "a69f3d24912fea7a6ef769b797449edb": "成長豆不足",
  "9342234c70c7ff04efb8d1dd341413ac": "立即兑換",
  "3e0cf6cf25dfa2f8d13908dcffbd300b": "立即支付",
  "23b9a391df9da79cd38db19850f855cb": "參數錯誤!",
  "12836810affe0aa90138d03ae352abcc": "支付中...",
  "8a81f31b60bcf273bb047297ea3f1dcd": "商品明細",
  "157d7443e1302a3f587cfa43f81efd0a": "價格明細",
  "4928e9df06efbb05832f40151a973615": "支付方式",
  "44d98997d8ccb61062c3425a262b4add": "成長豆兑換商品 若無質量問題不支持退換貨",
  "008c885d00e7761df2e800e58558ff2c": "商品詳情頁_挽留 彈窗曝光",
  "3049a87611b81d01f2521faa8a90b239": "商城",
  "78c923976c120f18344800b3e37eb85c": "商品詳情頁_挽留彈窗內容按鈕點擊",
  "87c126344a8907ba094a10364e87813e": "其他",
  "9d8aaf677170687608ead4dca1058592": "商品詳情頁_挽留彈窗底部按鈕點擊",
  "25faa1bbd1c61e39fbaee2ea6c799012": "放棄"
}
